import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=1bf5ad40&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"
import style0 from "./Personal.vue?vue&type=style&index=0&id=1bf5ad40&prod&lang=css"
import style1 from "./Personal.vue?vue&type=style&index=1&id=1bf5ad40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5ad40",
  null
  
)

export default component.exports